import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

export const initiativeList = (params = '') => Http.get(`/testimonial-initiatives${serialize(params)}`)
export const initiativeCreate = (params = '') => Http.post('/testimonial-initiatives', params)
export const initiativeByID = (params = '') => Http.get(`/testimonial-initiatives/${params}`)
export const initiativeUpdate = (params = '') => Http.put(`/testimonial-initiatives/${params.id}`, params)
export const initiativeDestroy = (params = '') => Http.delete(`/testimonial-initiatives/${params.id}`)
